<template>
  <cc-container class="invoice">
    <cc-header-nav title="我的发货单" url="/#/management">
      <cc-svg-icon @click="showDatePicker" size="20px" slot="right" icon-class="calendar"></cc-svg-icon>
    </cc-header-nav>
    <cc-fade>
      <div style="position:relative;">
        <cc-date-filter
          v-show="dateFilterVisible"
          @search="handleDateFilter"
          @cancel="emptyData"
          ref="dateFilter"
        ></cc-date-filter>
      </div>
    </cc-fade>
    <div class="search-box" style="border-bottom:5px solid #eeeeee;">
      <input
        v-model="delivery"
        class="input-search"
        type="text"
        placeholder="发货单搜索/订单号搜索"
        @keyup.13="search()"
      />
      <cc-svg-icon
        @click="delivery=''"
        size=".16rem"
        class-name="search-icon"
        :icon-class="iconVisible?'cancel':'search'"
      ></cc-svg-icon>
    </div>
    <cc-main id="container">
      <van-list
        class="invoice-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order v-if="list.length === 0 && m_loading === false" tip="亲，暂无相关发货单哦"></cc-not-order>

        <cc-animation-list>
          <invoice-item class="invoice-item" v-for="item in list" :key="item.id" :item="item"></invoice-item>
        </cc-animation-list>
      </van-list>
    </cc-main>

    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Lazyload, Radio, List } from 'vant'

import { types } from '@/store/modules/order'

import ListMixin from '@/mixins/list'
import InvoiceItem from './item.vue'
Vue.use(Lazyload)
  .use(Radio)
  .use(List)
export default {
  name: 'invoice',
  mixins: [ListMixin],
  components: {
    InvoiceItem
  },
  data () {
    return {
      // 搜索清除图标的显示隐藏
      iconVisible: false,
      start_time: null,
      end_time: null,
      list: [],
      delivery: '',
      offsetTop: 0,
      dateFilterVisible: false,
      conter: 0
    }
  },
  computed: {
    ...mapGetters(['getBoundList', 'getOrderDetail', 'getBoundDetail'])
  },
  watch: {
    delivery () {
      this.delivery.length > 0
        ? (this.iconVisible = true)
        : (this.iconVisible = false)
    }
  },
  created () {
    this.m_page.limit = 5
    this.loadData()
  },
  methods: {
    ...mapActions([
      types.GET_OUTBOUND_LIST,
      types.GET_ORDER_DETAIL,
      types.GET_OUTBOUND_DETAIL
    ]),
    handleDateFilter ({ startDate, endDate }) {
      this.start_time = startDate
      this.end_time = endDate
      this.search()
      this.dateFilterVisible = false
    },
    showDatePicker () {
      this.dateFilterVisible = ~this.dateFilterVisible
    },
    emptyData ({ startDate, endDate }) {
      // 父组件改变子组件的值
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      await this.GET_OUTBOUND_LIST({
        page: this.m_page.curr,
        limit: this.m_page.limit,
        delivery: this.delivery,
        start_time: this.start_time,
        end_time: this.end_time
      })
      this.$tips(
        this.getBoundList,
        {
          tip: false
        },
        res => {
          const data = res
          if (data.return_data.length === 0) {
            this.mEnd()
            if (this.list.length === 0) {
              this.m_finishedText = ''
            }
          } else {
            this.list = [...this.list, ...data.return_data]
            if (data.return_data.length < 10) {
              this.m_finishedText = '已全部加载完成'
              this.mEnd()
            }
          }
        }
      )
      this.mSuccess()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
.invoice {
  background: #fff;
}
.invoice {
  @include flex;
  .search-box {
    height: 40px;
    position: relative;
    @include center(column);
    .input-search {
      height: 28px;
      width: 91%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .invoice {
    &-list {
      @include flex(column);
    }
  }
}
</style>
